import React from 'react'
import { observer } from 'mobx-react'
import i18n from 'i18next'

import Modal from '../../../UniformComponents/Modal'
import ModalHeader from '../../../UniformComponents/ModalHeader'
import Button from '../../../UniformComponents/Button'

import './styles/UnsavedSkipLogicModal.scss'

const UnsavedSkipLogicModal = ({ store }) => {
    const handleCloseModals = () => {
        store.closeUnsavedSkipLogicModal()
        if (store.skipLogicConfig.type === 'option') {
            store.skipLogicConfig.question.skipLogic = store.previousSkipLogic.map((skipLogic) => store.survey.copySkipLogic(skipLogic))
        } else {
            store.survey.skipLogic = store.previousSkipLogic.map((skipLogic) => store.survey.copySkipLogic(skipLogic))
        }
        store.previousSkipLogic = undefined
        store.hasUnsavedSkipLogic = false
        store.skipLogicModalVisible = false
    }

    return (
        <Modal
            show={store.showUnsavedSkipLogicModal}
            onClose={store.closeUnsavedSkipLogicModal}
        >
            <ModalHeader>
                <div className="unsaved-text-container">
                    <h3>{i18n.t('skipLogicModal.unsavedTitle')}</h3>

                    <p>
                        {i18n.t('skipLogicModal.unsavedDescription')}
                    </p>
                </div>
            </ModalHeader>

            <div className="unsaved-buttons-container">
                <Button
                    label={i18n.t('skipLogicModal.goBack')}
                    cssClass="regular tertiary"
                    onClick={store.closeUnsavedSkipLogicModal}
                />

                <Button
                    label={i18n.t('skipLogicModal.yesClose')}
                    cssClass="regular primary"
                    onClick={handleCloseModals}
                />
            </div>
        </Modal>
    )
}

export default observer(UnsavedSkipLogicModal)
